import { render, staticRenderFns } from "./adminComplaintList.vue?vue&type=template&id=a3369d2c&scoped=true"
import script from "./adminComplaintList.vue?vue&type=script&lang=js"
export * from "./adminComplaintList.vue?vue&type=script&lang=js"
import style0 from "./adminComplaintList.vue?vue&type=style&index=0&id=a3369d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3369d2c",
  null
  
)

export default component.exports